import { PricingMethodology, ReferrerType } from '@constants/constants';
import { FinancingType } from '@api/deals';
import { PerformanceThresholdData } from './components/DealDetails/types';
import { PrepaymentConfigFormState } from './utils/prepaymentConfig';
import { RCVCollectionTermsFormFields } from './components/RCVDealConfigurations/types';
import { AggregatedDealInfo } from '@api/deals';

/** @deprecated - use the dedicated investor splits API instead */
export interface ContributionSplitColumn {
  fundingMonth: string;
  splits: InvestorData[];
}

export type DealConfigurationStatus = 'ACTIVE' | 'NONE' | 'INACTIVE' | 'FUTURE';
export interface DealDetailsFormState {
  agreementDate: string;
  /** @deprecated - use the dedicated investor splits API instead */
  investorRows: InvestorData[];
  /** @deprecated - use the dedicated investor splits API instead */
  contributionSplitColumns: ContributionSplitColumn[];
  enableAccountingRevenueCalculation: boolean;
  status: DealConfigurationStatus;
  investorSigningAuthority: string;
  validityEndDate: string;
  financingType: FinancingType | null;
}

export type AggregatedDealGameInfo = {
  gameId: string;
  gameName: string;
  disabled?: boolean;
  dealStructureId?: string;
  startCohort?: string;
  endCohort?: string;
};

export interface DealPricingData {
  interestPercentage: string;
  firstMonthCap: string;
  incrementalReturnCap: string;
  customPricing: string;
  firstNCohorts: string;
  firstNSuperProRata: string;
  firstNInterestRate: string;
  interestRate: string;
  totalReturnCap: string;
  simpleInterestRatchet: SimpleInterestRatchet[];
  dynamicReturnCapV2Ratchet: DynamicReturnCapV2Ratchet[];
  fixedRateRatchet: FixedRateRatchet[];
}
export interface DealConfigurationFormState extends Partial<RCVCollectionTermsFormFields> {
  dealStructureId: string;
  pricingMethodology: PricingMethodology;
  interestOnUnderspendAmount: string;
  pricingData: DealPricingData;
  cohortMonthOffset: number;
  contractTemplate: string;
  startCohort: string;
  endCohort: string;
  status: DealConfigurationStatus;
  targetIrr: string;
  expectedPaybackPeriod: number;
  performanceThresholds: PerformanceThresholdData;
  prepaymentConfig: PrepaymentConfigFormState | null;
  gracePeriod: number;
  crossCollatEnabled: boolean;
  aggregatedDeal?: AggregatedDealInfo;
  acceleratedRecoupStrategy: AcceleratedRecoupStrategy;
}
export enum AcceleratedRecoupStrategy {
  ACCELERATED_RECOUP = 'ACCELERATED_RECOUP',
  PAY_TO_THRESHOLDS = 'PAY_TO_THRESHOLDS',
}

export const ACCELERATED_RECOUP_STRATEGY_LABELS = {
  [AcceleratedRecoupStrategy.ACCELERATED_RECOUP]: 'Accelerated Recoup',
  [AcceleratedRecoupStrategy.PAY_TO_THRESHOLDS]: 'Pay to Thresholds',
};
export interface InvestorData {
  id: number;
  investorId: string;
  investorName: string;
  investorContribution: string;
  investorReturnCap: string;
}

export interface SimpleInterestRatchet {
  start: string;
  end: string;
  simpleInterest: string;
}

export interface DynamicReturnCapV2Ratchet {
  start: string;
  end: string;
  baseRate: string;
  dynamicRate: string;
}

export interface FixedRateRatchet {
  start: string;
  end: string;
  fixedRate: string;
}

export enum PricingMethodologyTab {
  ACTIVE = 'Active',
  FUTURE = 'Future',
  ELAPSED = 'Elapsed',
}

export const REFERRER_TYPE_LABELS = {
  [ReferrerType.SALES]: 'Sales',
  [ReferrerType.REFERRER]: 'Referrer',
};

export const DEAL_CONFIGURATION_STATUS_MAP: Record<DealConfigurationStatus, string> = {
  ACTIVE: 'Active',
  NONE: 'None',
  INACTIVE: 'Inactive',
  FUTURE: 'Future',
};
